import { mutator } from 'satcheljs';
import onMessageClassificationsResponse from '../actions/actionCreators/onMessageClassificationsResponse';
import store from '../store/store';

mutator(onMessageClassificationsResponse, actionMessage => {
    store.messageClassifications = actionMessage.messageClassifications;
});
